module.exports = __webpack_public_path__ + "img/avatar3.9f98f7be.png";